import { FunctionDict, FunctionTemplatesByFunctionId } from "src/globalTypes";
import { FunctionType } from "src/requests/functions/types";

interface FunctionFilterParams {
  functionId: number;
  functionsById: FunctionDict;
  functionTemplates?: FunctionTemplatesByFunctionId;
}

type FunctionFilterType = (params: FunctionFilterParams) => boolean;

const isWorkflowAdnNotCommon = (
  functionId: number,
  functionsById: FunctionDict
): boolean => {
  const concreteFnc = functionsById[functionId];

  if (!concreteFnc) return false;

  return concreteFnc.type === FunctionType.HegWorkflow && !concreteFnc.isCommon;
};

const hasFunctionConditions = (
  functionId: number,
  functionTemplates: FunctionTemplatesByFunctionId | undefined
): boolean => {
  if (!functionTemplates) return false;

  return !!functionTemplates[functionId].displayConditions?.length;
};

export const isFunctionStandard: FunctionFilterType = ({
  functionId,
  functionsById,
  functionTemplates,
}) => {
  const concreteFnc = functionsById[functionId];

  if (!concreteFnc) return false;

  return (
    concreteFnc.type !== FunctionType.HegWorkflow &&
    !concreteFnc.isCommon &&
    !hasFunctionConditions(functionId, functionTemplates)
  );
};

export const isFunctionWorkflow: FunctionFilterType = ({
  functionId,
  functionsById,
  functionTemplates,
}) => {
  if (!functionsById[functionId]) return false;
  return (
    isWorkflowAdnNotCommon(functionId, functionsById) ||
    hasFunctionConditions(functionId, functionTemplates)
  );
};
